export default __webpack_public_path__ + "static/media/bg.36fcf44e.png";